import { defaultFill } from './utils/constants';
var muiChevronUpBase = {
    paths: [
        {
            path: 'M0.295302013,6.68060837 C0.0984340045,6.48542459 0,6.23700887 0,5.93536122 C0,5.63371356 0.0984340045,5.38529785 0.295302013,5.19011407 L5.23489933,0.292775665 C5.34228188,0.186311787 5.45861298,0.110899873 5.58389262,0.066539924 C5.70917226,0.0221799747 5.84340045,0 5.98657718,0 C6.12975391,0 6.2639821,0.0221799747 6.38926174,0.066539924 C6.51454139,0.110899873 6.63087248,0.186311787 6.73825503,0.292775665 L11.704698,5.21673004 C11.901566,5.41191381 12,5.65145754 12,5.93536122 C12,6.21926489 11.8926174,6.46768061 11.6778523,6.68060837 C11.4809843,6.87579214 11.2304251,6.97338403 10.9261745,6.97338403 C10.6219239,6.97338403 10.3713647,6.87579214 10.1744966,6.68060837 L5.98657718,2.52851711 L1.77181208,6.70722433 C1.57494407,6.90240811 1.33333333,7 1.04697987,7 C0.760626398,7 0.510067114,6.89353612 0.295302013,6.68060837 Z',
            fill: defaultFill,
        },
    ],
    title: 'chevron up',
    width: 24,
    height: 24,
    rotate: 0,
    translate: [6, 8],
};
var muiChevronUp = {
    base: muiChevronUpBase,
};
export { muiChevronUp };
//# sourceMappingURL=chevronUp.js.map